import { generateTable, initAnnotations } from "../../../ui/table/Utils.js";
import { openColorPicker, openLabelSelection } from "../../layer/GeoJSONLayer.js";

import "./geoJSONLayer.css";

const excludedAnnotations = ["Geodesic Area", "Distance", "Coordinates", "North West", "South East", "Color", "Label"]

/**
 * @memberof vef.map.popup.templates
 */
export function geoJSONLayer(content, response, layer, style) {
    if (!content.features) content = { features: [content] };

    const responses = [];
    for (let i = 0; i < content.features.length; i++) {
        const properties = content.features[i].properties;

        if (!("Label" in properties)) properties.Label = null;

        let html = generateTable(properties, {}, true);
        if (style != "sidebar") {
            initAnnotations(html, properties, excludedAnnotations);

            // handling of color picker
            const colorRow = html.querySelector("tr>td:first-child[title='Color']").parentElement;

            const colorValueCell = colorRow.querySelector("td:last-child");
            colorValueCell.classList.add("popup-color-cell");
            colorValueCell.innerHTML = "<div class='popup-color-indicator'></div><a href='#'></a>";

            const colorValueCellLink = colorValueCell.querySelector("a");
            const colorIndicator = colorValueCell.querySelector(".popup-color-indicator");

            if (properties.Color) {
                colorIndicator.style.backgroundColor = properties.Color;
                colorValueCellLink.innerText = properties.Color;
                colorValueCellLink.title = properties.Color;
            }

            colorRow.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                openColorPicker(color => {
                    layer.setColor(content.features[i], color);
                    colorIndicator.style.backgroundColor = properties.Color;
                    colorValueCellLink.innerText = color;
                    colorValueCellLink.title = color;
                });
            });

            // handling label selection
            const labelRow = html.querySelector("tr>td:first-child[title='Label']").parentElement;
            const labelValueCell = labelRow.querySelector("td:last-child");
            labelValueCell.innerHTML = "<i><a href='#'></a></i>";
            const labelValueCellLink = labelValueCell.querySelector("a");

            if (properties.Label == null) {
                labelValueCellLink.innerText = "not specified";
                labelValueCellLink.title = "not specified";
            } else {
                labelValueCellLink.innerText = properties.Label;
                labelValueCellLink.title = properties.Label;
            }

            labelRow.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                openLabelSelection(properties.Label, label => {
                    layer.setLabel(content.features[i], label);
                    if (label == null) {
                        labelValueCellLink.innerText = "not specified";
                        labelValueCellLink.title = "not specified";
                    } else {
                        labelValueCellLink.innerText = properties.Label;
                        labelValueCellLink.title = properties.Label;
                    }
                });
            })

        }

        if (html) responses.push({
            response: response,
            feature: content.features[i],
            layer: layer,
            title: layer.title,
            html: html
        });
    }

    return responses;
}